import * as Yup from 'yup';
import { ObjectSchema } from 'yup';

export const sharedPageSchema = (): ObjectSchema =>
  Yup.object().shape({
    safetyCheck: Yup.boolean().oneOf([true]),
  });
